import {useDropZone} from "@codecks/dnd";
import {api} from "../../lib/api";
import messenger from "../../lib/messenger";
import {waitForResult} from "../../lib/wait-for-result";
import {checkDropCards, useAddCardToParent} from "../workflows/workflow-utils";
import {RawDropArea as RawRawDropArea} from "../../components/uploader/DropArea";
import {Card, CardId} from "../../cdx-models/Card";

const RawDropArea = RawRawDropArea as any;

export const DropChildCardArea = ({card}: {card: Card}) => {
  const update = useAddCardToParent();
  const parentCardId = card.$meta.getId("parentCard", null);
  const targetParentCard = parentCardId ? card.parentCard : card;
  const handleDrop = ({item}: any) => {
    const {canDrop: innerCanDrop} = checkDropCards(card, item.data.cardInfos);
    if (innerCanDrop) {
      const {cardInfos} = item.data;
      return update({
        parentCardId: parentCardId || (card.cardId as CardId),
        childCardIds: cardInfos.map((i: any) => i.cardId),
      }).then(() => {
        waitForResult(
          () => {
            const targetCard = api.getModel({modelName: "card", id: parentCardId || card.cardId});
            return [
              cardInfos.length === 1
                ? "The dropped card is now a sub card"
                : `These ${cardInfos.length} dropped cards are now sub cards`,
              `of '${targetCard.title}'.`,
            ];
          },
          (parts: any) => messenger.send(parts.join(" "))
        );
      });
    }
  };

  const {
    dragItem,
    isOver,
    ref: dropRef,
  } = useDropZone({
    type: "CARD",
    onDrop: handleDrop,
  });
  if (!dragItem) return null;
  if (!targetParentCard) return null;

  const {canDrop, msg, isAlreadyChild} = checkDropCards(targetParentCard, dragItem.data.cardInfos);
  if (isAlreadyChild) return null;

  const getLabel = () => {
    if (msg) return msg;
    if (parentCardId) {
      return `Add as sub card${
        dragItem.data.cardInfos.length === 1 ? "" : "s"
      } to current Hero card`;
    }
    return `Add as sub card${dragItem.data.cardInfos.length === 1 ? "" : "s"}`;
  };

  return (
    <RawDropArea isOver={isOver} ref={dropRef} hasError={!canDrop}>
      {getLabel()}
    </RawDropArea>
  );
};
